const BottomBar = {
  options: {
    customization: {
      items: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 9,
      },
      items_2: {
        type: 'DraggableList',
        data: {
          internalLinking: true,
          textEditable: true,
        },
        order: 9,
      },
      iconColor: {
        type: 'HexColor',
        order: 1,
      },
      backgroundColor: {
        type: 'HexColor',
        order: 2,
      },
      selectedIconColor: {
        type: 'HexColor',
        order: 3,
      },
      selectedBackgroundColor: {
        type: 'HexColor',
        order: 4,
      },
      selectedBorderColor: {
        type: 'HexColor',
        order: 5,
      },
      staticBackgroundColor: {
        type: 'HexColor',
        order: 5,
      },
      staticIconColor: {
        type: 'HexColor',
        order: 5,
      },
      labelLocation: {
        type: 'Toggle',
        order: 6,
      },
      accentColor: {
        type: 'HexColor',
        order: 7,
      },
      accentBackgroundColor: {
        type: 'HexColor',
        order: 8,
      },
      isShowBottomBarInCheckOut: {
        type: 'Toggle',
        order: 9,
      },
    },
    widgets: {
      Menu_CartSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'cartSettings',
        },
        options: {
          cartIcon: {
            type: 'IconSelector',
            data: {
              defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005380645.png',
            },
            order: 24,
          },
          cartIconBackgroundColor: {
            type: 'HexColor',
            order: 25,
          },
          cartIconColor: {
            type: 'HexColor',
            order: 26,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'BottomBar_1',
      name: 'BottomBar_1',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: false,
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_0.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_2',
      name: 'BottomBar_2',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#000000',
        labelLocation: false,
        selectedBackgroundColor: '#ebebeb',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'BottomBar_3',
      name: 'BottomBar_3',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#FFFFFF',
        selectedBackgroundColor: '#ebebeb',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_4',
      name: 'BottomBar_4',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        selectedBorderColor: '#7059EF',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_3.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_5',
      name: 'BottomBar_5',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        staticBackgroundColor: '#000000',
        staticIconColor: '#FFFFFF',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_4.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_6',
      name: 'BottomBar_6',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: true,
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_5.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_7',
      name: 'BottomBar_7',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: 'top',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_6.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'BottomBar_8',
      name: 'BottomBar_8',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: true,
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_7.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'BottomBar_9',
      name: 'BottomBar_9',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: 'top',
        selectedBackgroundColor: '#ebebeb',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_8.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_10',
      name: 'BottomBar_10',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        selectedBackgroundColor: '#ebebeb',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_9.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_11',
      name: 'BottomBar_11',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504899_c4a27194-6576-4242-9f31-80dc0dc97dc0.png',
            name: 'Sepetim',
            image: {
              text: 'Sepetim',
            },
            label: 'Sepet',
            pointTo: {
              pointTo: 'Cart',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '4',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '5',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706004705313.png',
            name: 'Profil',
            image: {
              text: 'Profil',
            },
            label: 'Profil',
            pointTo: {
              pointTo: 'Profile',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        labelLocation: false,
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_10.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'BottomBar_12',
      name: 'BottomBar_12',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items_2: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005380645.png',
        cartIconBackgroundColor: '#553BEB',
        cartIconColor: '#FFFFFF',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/bottomBar_12.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
      isNew: true,
      isHiddenOnWebview: false,
    },
    {
      id: 'BottomBar_Yenir',
      name: 'BottomBar_Yenir',
      type: 'BottomBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        items_2: [
          {
            id: '1',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504907_c592738c-6d96-4be1-bb71-021869524681.png',
            name: 'Anasayfa',
            image: {
              text: 'Anasayfa',
            },
            label: 'Anasayfa',
            pointTo: {
              pointTo: 'Main',
              pointToType: 'defaultPage',
            },
            selector: 'Shopping, Ecommerce - Linear',
            internalLinking: true,
          },
          {
            id: '2',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005493454.png',
            name: 'Kategoriler',
            image: {
              text: 'Kategoriler',
            },
            label: 'Kategoriler',
            pointTo: {
              pointTo: 'Category',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
          {
            id: '3',
            url: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005142103.png',
            name: 'Favorilerim',
            image: {
              text: 'Favorilerim',
            },
            label: 'Kampanyalar',
            pointTo: {
              pointTo: 'Favorite',
              pointToType: 'defaultPage',
            },
            selector: 'general',
            internalLinking: true,
          },
        ],
        iconColor: '#000000',
        backgroundColor: '#FFFFFF',
        selectedIconColor: '#7059EF',
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005380645.png',
        cartIconBackgroundColor: '#553BEB',
        cartIconColor: '#FFFFFF',
        isShowBottomBarInCheckOut: false,
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/BottomBar_Yenir.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
      isNew: false,
      isHiddenOnWebview: true,
    },
  ],
};

export default BottomBar;
